import React, { useMemo, useRef, ForwardedRef } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { TPieChartGenders } from './types.d';

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChartGenders: React.FC<TPieChartGenders> = ({ portfolioGenders, bgColors }) => {
  const chartRef = useRef<ChartJS<'pie'>>(null);

  const data = useMemo(
    () => ({
      labels: portfolioGenders?.map((x) => x.GENERO),
      datasets: [
        {
          data: portfolioGenders?.map((x) => x.PORCENTAJE),
          backgroundColor: bgColors,
          hoverBackgroundColor: bgColors,
          borderWidth: 2,
          borderColor: '#ffffff',
          hoverOffset: 14,
        },
      ],
    }),
    [portfolioGenders, bgColors]
  );

  const options: ChartOptions<'pie'> = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 1100,
      easing: 'easeOutQuart',
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          padding: 18,
          font: {
            size: 12,
            weight: 500,
          },
        },
      },
      tooltip: {
        backgroundColor: '#1e3a5f',
        borderColor: '#64b5f6',
        borderWidth: 1,
        padding: 12,
        callbacks: {
          label: (ctx) => {
            const index = ctx.dataIndex;
            const item = portfolioGenders[index];
            return ` ${item.GENERO}: ${item.CANTIDAD} (${item.PORCENTAJE}%)`;
          },
        },
      },
    },
  };

  return (
    <div
      style={{
        width: '100%',
        flex: 1,
        minHeight: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}>
      <Pie ref={chartRef as ForwardedRef<any>} data={data} options={options} />
    </div>
  );
};

export default PieChartGenders;
